<template>
  <div class="viewPersonnel">
    <el-form ref="ruleForm" class="ruleForm" :model="ruleForm" label-width="120px">
      <div class="title">
        <div class="titleChild">
          <el-form-item :label="$t('personnel.addpersonnel.dataStatus')">
            <el-input v-model="ruleForm.dataStatus" disabled></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="people">
        <div class="picture">
          <img v-if="ruleForm.personPhoto" :src="ruleForm.personPhoto" />
        </div>
        <div class="peopleInformation">
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('personnel.addpersonnel.personNo')">
                <el-input v-model="ruleForm.personNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('personnel.addpersonnel.personSex')">
                <el-select v-model="ruleForm.personSex" disabled>
                  <el-option :label="$t('personnel.addpersonnel.boy')" value="1"></el-option>
                  <el-option :label="$t('personnel.addpersonnel.girl')" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('personnel.addpersonnel.personName')" prop="personName">
                <el-input
                  v-model="ruleForm.personName"
                  clearable
                  maxlength="32"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-tooltip
              :disabled="!ruleForm.oaId"
              class="item"
              effect="dark"
              :content="String(ruleForm.oaId)"
              placement="top"
            >
              <el-col :span="8">
                <el-form-item :label="$t('personnel.addpersonnel.oaId')" prop="oaId">
                  <el-input v-model="ruleForm.oaId" clearable maxlength="32" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-tooltip>
          </el-row>
        </div>
      </div>
      <div class="common-tab tab">
        <el-tabs v-model="activeName" type="border-card">
          <!-- 公司信息 -->
          <el-tab-pane label="公司信息" name="first">
            <div class="tabArea">
              <TableCompent
                class="TableCompent"
                :editCompany="editCompany"
                ref="TableCompent"
              ></TableCompent>

              <div style="margin-top: 10px">
                <el-row>
                  <el-col :span="24">
                    <div class="companytitle">{{ $t('personnel.addpersonnel.phoneWays') }}</div>
                  </el-col>
                </el-row>
                <el-row class="ruleForm">
                  <el-col :span="24">
                    <div style="float: left">
                      <el-form-item :label="$t('personnel.table.phone')" label-width="120px">
                        <el-input v-model="ruleForm.personMobilePhone" disabled></el-input>
                      </el-form-item>
                    </div>
                    <div style="float: left">
                      <el-form-item :label="$t('personnel.addpersonnel.email')" label-width="120px">
                        <el-tooltip
                          :disabled="!ruleForm.personEmail"
                          class="item"
                          effect="dark"
                          :content="String(ruleForm.personEmail)"
                          placement="top"
                        >
                          <el-input v-model="ruleForm.personEmail" disabled></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <!-- 个人信息 -->
          <el-tab-pane
            v-if="showComAndSelf"
            :label="$t('personnel.addpersonnel.adminInformation')"
            name="second"
          >
            <div class="tabArea">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="selfInformation">
                    <!-- <el-form-item :label="$t('personnel.addpersonnel.personNational')" label-width="120px">
                      <el-input v-model="ruleForm.personNational" disabled></el-input>
                    </el-form-item>-->
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personNational')"
                      prop="personNational"
                      label-width="120px"
                    >
                      <el-select v-model="ruleForm.personNational" class="personNational" disabled>
                        <el-option
                          :label="item.label"
                          :value="item.value"
                          v-for="(item, index) in nationalityList"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personId')"
                      label-width="120px"
                    >
                      <el-input v-model="ruleForm.personId" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.passportId')"
                      label-width="120px"
                    >
                      <el-input v-model="ruleForm.passportId" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div></div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="companytitle top">{{
                    $t('personnel.addpersonnel.bankInformation')
                  }}</div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personBankAccount')"
                      label-width="120px"
                    >
                      <el-input v-model="ruleForm.personBankAccount" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personDepositBank')"
                      label-width="120px"
                    >
                      <el-input v-model="ruleForm.personDepositBank" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personAccountName')"
                      label-width="120px"
                    >
                      <el-input v-model="ruleForm.personAccountName" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personBankReservation')"
                      label-width="120px"
                    >
                      <el-input v-model="ruleForm.personBankReservation" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.bankCardFrontPhotos')"
                      label-width="120px"
                    >
                      <div class="idCard">
                        <img v-if="ruleForm.bankCardFront" :src="ruleForm.bankCardFront" />
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.bankCardBackPhotos')"
                      label-width="120px"
                    >
                      <div class="idCard">
                        <img v-if="ruleForm.bankCardBack" :src="ruleForm.bankCardBack" />
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <!-- 系统映射表 -->
          <el-tab-pane :label="$t('personnel.addpersonnel.pushMapLinkList')" name="third">
            <div class="tabArea">
              <sirui-table
                ref="systemMappingTable"
                :loading="load"
                :data="systemMappingTableData"
                :paging="false"
              >
                <vxe-table-column
                  v-for="(item, index) in systemMappingTableList"
                  :key="index"
                  :width="item.width"
                  :field="item.prop"
                  :title="item.label"
                ></vxe-table-column>
              </sirui-table>
            </div>
          </el-tab-pane>
          <!-- 历史记录 -->
          <el-tab-pane :label="$t('personnel.addpersonnel.viewHistory')" name="fourth">
            <div class="tabArea">
              <sirui-table
                ref="historicalRecord"
                :loading="load"
                :data="historicalRecordTableData"
                :paging="true"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
              >
                <vxe-table-column
                  type="index"
                  :title="$t('personnel.table.index')"
                ></vxe-table-column>
                <vxe-table-column
                  v-for="(item, index) in historicalRecordList"
                  :key="index"
                  :width="item.width"
                  :field="item.prop"
                  :title="item.label"
                ></vxe-table-column>
              </sirui-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-form>
    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050815455225611']"
        type="primary"
        class="fixed-bottom-btn"
        v-if="(ruleForm.dataStatusCode == 'ZT02' ? false : true) && showComAndSelf"
        @click="editPersonnel"
        >{{ $t('personnel.addpersonnel.modify') }}</el-button
      >
      <el-button
        type="primary"
        class="fixed-bottom-btn outLineColor"
        v-if="selfDisable ? adminFlag != 2 : false"
        :loading="buttonloading"
        @click="changeStatic('ZT04')"
        >{{ $t('personnel.addpersonnel.Prohibit') }}</el-button
      >
      <el-button
        type="primary"
        class="fixed-bottom-btn plusColor"
        style="background: #6abefd"
        v-if="selfDisable ? adminFlag != 2 : false"
        :loading="buttonloading"
        @click="changeStatic('ZT03')"
        >{{ $t('personnel.addpersonnel.Enable') }}</el-button
      >
      <el-button
        type="primary"
        class="fixed-bottom-btn outLineColor"
        :loading="buttonloading"
        v-if="ruleForm.dataStatusCode == 'ZT05' ? true : false"
        @click="getUp"
        >{{ $t('personnel.button.getUp') }}</el-button
      >
      <el-button type="primary" v-if="!editCompany" @click="submitHandler">提交</el-button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/masterData/personnel';
  import companyAPI from '@/api/masterData/company';
  import TableCompent from '../personnel/components/tableCompent';
  export default {
    name: 'viewPersonnel',
    components: {
      SiruiTable,
      TableCompent,
    },
    computed: {
      editCompany() {
        // 如果是超级管理员进来的时候可以编辑,否则不可以
        if (this.adminFlag == '') {
          return false;
        } else {
          return true;
        }
      },
      systemMappingTableList() {
        return [
          {
            prop: 'middleClass',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
          {
            prop: 'middleClassValue',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
          {
            prop: 'mappingSystem',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
          {
            prop: 'mappingClass',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
          {
            prop: 'mappingClassValue',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
        ];
      },
      historicalRecordList() {
        return [
          { prop: 'gmtCreate', label: this.$t('personnel.addpersonnel.time') },
          {
            prop: 'updateContent',
            label: this.$t('personnel.addpersonnel.changeInformation'),
          },
        ];
      },
      partnerData() {
        // 获取路由参数
        return this.$route.query;
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        //获取国籍
        nationalityList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'person_national').dictList;
          }
        },
      }),
      adminFlag() {
        return this.userInfo.userInfo.adminFlag;
      },
      user() {
        return this.userInfo.userInfo;
      },
      adminDisabled() {
        //管理员按钮权限
        if (this.userInfo.userInfo.adminFlag == 1) {
          return true;
        } else {
          return false;
        }
      },
    },
    data() {
      return {
        buttonloading: false,
        selfDisable: false,
        showComAndSelf: false,
        load: false,
        type: 'person',
        systemMappingTableData: [],
        historicalRecordTableData: [],
        ruleForm: {
          personPhoto: '',
          dataStatus: '', //当前状态
          dataStatusCode: '',
          personNo: '', //编号
          personName: '', //姓名
          personSex: '1', //性别
          personCompanyDos: [], //公司信息
          personMobilePhone: '',
          personEmail: '',
          personNational: '', //国籍
          personId: '', //身份证号
          passportId: '', //护照号
          personBankAccount: '', //银行账号
          personDepositBank: '', //开户行
          personAccountName: '', //开户名
          personBankReservation: '', //银行预留电话
          bankCardFront: '',
          bankCardBack: '',
        },
        activeName: 'first',
      };
    },
    mounted() {
      this.getData();
      this.getHistory();
    },
    methods: {
      // admin登录的时候可以修改提交
      async submitHandler() {
        const tableData = await this.$refs.TableCompent.fullValidEvent();
        if (!tableData) {
          this.$message.error('请补充资料');
          return;
        }
        const tableList = tableData.personCompanyDos;
        console.log(this.ruleForm);
        const postData = tableList.map((item) => {
          return {
            ...item,
            personId: item.personId ? item.personId : this.ruleForm.id,
            personNo: item.personNo ? item.personNo : this.ruleForm.personNo,
          };
        });
        console.log(postData, '提交数据');
        const { data } = await this.$axios.post(API.UPDATE_DEPARTMENT, postData);
        if (data.code == 0) {
          this.$message.success('更新成功');
          this.$router.push('/masterData/personnel');
        } else {
          this.$message.error('更新失败');
        }
      },
      //修改
      editPersonnel() {
        let pathList = {
          fromPath: {
            path: '/masterData/viewPersonnel',
            name: 'viewPersonnel',
            meta: {
              keepAlive: true,
              title: this.$t('personnel.addpersonnel.viewPeople'),
            },
          },
          toPath: {
            path: '/masterData/editPersonnel',
            name: 'editPersonnel',
            meta: {
              keepAlive: true,
              title: this.$t('personnel.addpersonnel.editPersonnel'),
            },
            query: this.partnerData,
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      //放弃
      getUp() {
        let params = {
          id: this.partnerData.id,
          personNo: this.ruleForm.personNo,
          version: this.partnerData.version,
        };
        this.buttonloading = true;
        this.$axios.post(API.UPDATE_PERSON_FOR_GIVE_UP, params).then((res) => {
          this.buttonloading = false;
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: this.$t('personnel.wrongTitle.gitUpSucess'),
              type: 'success',
            });
            let pathList = {
              fromPath: {
                path: '/masterData/viewPersonnel',
                name: 'viewPersonnel',
                meta: {
                  keepAlive: true,
                  title: this.$t('personnel.addpersonnel.viewPeople'),
                },
              },
              toPath: {
                path: '/masterData/personnel',
                name: 'personnel',
                meta: {
                  keepAlive: false,
                  title: this.$t('personnel.addpersonnel.personnel'),
                },
              },
            };
            this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
              this.$nextTick(() => {
                this.$router.push(pathList.toPath);
              });
            });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //更改状态
      changeStatic(value) {
        let persons = [
          {
            id: this.partnerData.id,
            version: this.partnerData.version,
            dataStatus: value,
          },
        ];
        let dataFlag = false;
        if (value == 'ZT04') {
          if (this.ruleForm.dataStatusCode != 'ZT03') {
            dataFlag = true;
          }
        } else {
          if (this.ruleForm.dataStatusCode != 'ZT04') {
            dataFlag = true;
          }
        }
        if (dataFlag) {
          this.$message({
            showClose: true,
            message: this.$t('personnel.wrongTitle.canDoIt'),
            type: 'error',
          });
        } else {
          let params = {};
          params.persons = JSON.stringify(persons);
          this.buttonloading = true;
          this.$axios.get(API.PERSONNEL_DISABLEORENTABLE, params).then((res) => {
            this.buttonloading = false;
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.getData();
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      // 获取历史记录
      getHistory() {
        const { pageSize, pageNum } = this.$refs.historicalRecord.page;
        const params = {
          className: this.type,
          dataNo: this.partnerData.id,
          pageNum,
          pageSize,
        };
        this.$axios.post(companyAPI.GET_HISTORY_LIST, params).then((res) => {
          if (0 == res.data.code) {
            this.historicalRecordTableData = res.data.data.list;
            this.$refs.historicalRecord.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 修改每页条数
      handleSizeChange() {
        this.getHistory();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getHistory();
      },
      //获取数据
      getData() {
        const params = {
          id: this.partnerData.id,
          version: this.partnerData.version,
          adminFlag: this.userInfo.userInfo.adminFlag,
        };
        this.loading.startLoading();
        this.$axios.get(API.LIST_PERSONNEL_SEARCH, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.ruleForm = res.data.data;
            /* this.ruleForm.personCompanyDos = JSON.parse(
            res.data.data.personCompanyDos
          ); */
            this.$refs.TableCompent.personCompanyDos = JSON.parse(res.data.data.personCompanyDos);
            console.log(this.ruleForm.personCompanyDos);
            this.ruleForm.personSex = JSON.stringify(res.data.data.personSex);
            if (this.userInfo.userInfo.userCode == this.partnerData.id || this.adminDisabled) {
              this.showComAndSelf = true;
            } else {
              this.showComAndSelf = false;
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .viewPersonnel {
    font-size: 12px;
  }
  .viewPersonnel .title {
    height: 84px;
    background-color: #fff;
  }
  .viewPersonnel .color {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
  }
  .viewPersonnel .outLineColor {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
  }
  .viewPersonnel .plusColor {
    background-color: #6abefd !important;
    border: 1px solid #6abefd !important;
    min-width: 80px;
    border-radius: 2px !important;
  }
  .viewPersonnel .titleChild {
    height: 32px;
    width: 200px;
    z-index: 0;
    padding-top: 26px;
    padding-left: 30px;
  }
  .viewPersonnel .people {
    height: 131px;
    background-color: #fff;
    margin-top: 10px;
    box-sizing: border-box;
    padding-top: 26px;
    padding-left: 30px;
  }
  .viewPersonnel .people .el-input--small {
    width: 142px;
  }
  .viewPersonnel .selfInformation .el-input--small {
    width: 142px;
  }
  .viewPersonnel .personNational {
    width: 142px;
  }
  .viewPersonnel .top {
    margin: 10px 0;
  }
  .viewPersonnel .callWays .el-input--small {
    width: 142px;
  }
  .viewPersonnel .people .el-select {
    width: 142px;
  }
  .viewPersonnel .people .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 8px !important;
  }
  .viewPersonnel .picture {
    width: 60px;
    height: 79px;
    border: 1px solid #e4e7ed;
    float: left;
  }
  .viewPersonnel .picture > img {
    width: 100%;
    height: 100%;
  }
  .viewPersonnel .peopleInformation {
    height: 79px;
    width: 800px;
    float: left;
    margin-left: 10px;
    /* background: blue; */
  }
  .viewPersonnel .tab {
    margin-top: 10px;
    margin-bottom: 90px;
    background-color: #fff;
  }
  .viewPersonnel .tabArea {
    box-sizing: border-box;
    padding-top: 10px;
  }
  .viewPersonnel .tabArea .el-tabs__content {
    overflow: hidden;
    padding: 10px;
    position: relative;
  }
  .viewPersonnel .tab .el-tabs__nav-scroll {
    background: #f3f6fa;
  }
  .viewPersonnel .companytitle {
    margin-bottom: 10px;
  }
  .viewPersonnel .button {
    height: 78px;
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .viewPersonnel .buttonList {
    height: 32px;
    margin: auto;
    width: fit-content;
    padding-top: 23px;
  }
  .viewPersonnel .buttonStyle {
    border: none;
    width: 102px;
    height: 32px;
  }
  .viewPersonnel .idCard {
    width: 347px;
    height: 173px;
    margin-top: 10px;
    border: 1px solid #e4e7ed;
  }
  .viewPersonnel .idCard > img {
    width: 100%;
    height: 100%;
  }
  .common-tab {
    .el-tabs {
      padding: 20px;
    }
    ::v-deep.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      color: #000000;
    }
    ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
      color: #000000;
    }
    ::v-deep .el-tabs__item {
      color: #000000;
    }
  }
</style>
